import React, { useEffect, useState } from "react";
import { Bell, BellRing, BellOff, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { enablePush, disablePush, getPushStatus } from "@/lib/push";
import { api } from "@/lib/api";

export function PushBell() {
  const [status, setStatus] = useState("loading");
  const [busy, setBusy] = useState(false);

  useEffect(() => { getPushStatus().then(setStatus); }, []);
  if (status === "loading" || status === "unsupported") return null;

  const onClick = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (status === "enabled") {
        await disablePush();
        setStatus("off");
        toast.success("Notifications off");
      } else if (status === "denied") {
        toast.error("Notifications are blocked for this site — enable them in your browser settings");
      } else {
        await enablePush();
        setStatus("enabled");
        toast.success("Notifications on — we'll ping you the moment a deal needs you");
        try { await api.post("/push/test"); } catch {}
      }
    } catch (e) {
      if (e?.message === "denied") toast.error("Permission declined — you can enable it later from browser settings");
      else toast.error("Couldn't enable notifications on this device");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={onClick}
      title={status === "enabled" ? "Notifications on — tap to turn off" : "Turn on notifications"}
      className={`grid place-items-center size-9 rounded-full border transition-colors ${
        status === "enabled"
          ? "border-[#0055FF]/50 bg-[#0055FF]/15 text-[#7da9ff]"
          : "border-white/20 bg-white/[0.04] text-white/70 hover:bg-white/[0.08]"
      }`}
      data-testid="push-bell"
    >
      {busy ? <Loader2 className="size-4 animate-spin" />
        : status === "enabled" ? <BellRing className="size-4" />
        : status === "denied" ? <BellOff className="size-4" />
        : <Bell className="size-4" />}
    </button>
  );
}
